import { Routes, Route } from "react-router-dom";
import SampleImage from "../components/SampleImage/SampleImage";
import MainLayout from "../components/MainLayout/MainLayout";
import SampleVideo from "../components/SampleVideo/SampleVideo";
import SampleAudio from "../components/SampleAudio/SampleAudio";
import SampleDocument from "../components/SampleDocument/SampleDocument";
import ConvertJpgToPng from "../components/ConvertJpgToPng/ConvertJpgToPng";
import Home from "../components/Home/Home";
import SampleArchives from "../components/SampleArchives/SampleArchives";
import SampleCode from "../components/SampleCode/SampleCode";
import PlaceholderImageGenerator from "../components/PlaceholderImageGenerator/PlaceholderImageGenerator";
import FileDetails from "../components/FileDetails/FileDetails";
import PrivacyPolicy from "../components/PrivacyPolicy/PrivacyPolicy";
import TermsOfService from "../components/TermsOfService/TermsOfService";
import ConvertJpgToPngBlog from "../components/BlogSection/ConvertJpgToPngBlog";
import SampleFilesGuide from "../components/BlogSection/SampleFilesGuide";
import ImageFormatComparison from "../components/BlogSection/ImageFormatComparison";
import AboutUs from "../components/AboutUs/AboutUs";
import ContactUs from "../components/ContactUs/ContactUs";
import NotFound from "../components/NotFound/NotFound";
import Blogs from "../components/Blogs/Blogs";
import ImageOptimization from "../components/BlogSection/ImageOptimization";
import FileUploadSecurity from "../components/BlogSection/FileUploadSecurity";
import PNGTroubleshooter from "../components/BlogSection/PNGParadox";
import AVIFNextGenImage from "../components/BlogSection/AVIFNextGenImage";
import FileThreat from "../components/BlogSection/FileThreat";
import WhenUsePdfAndDoc from "../components/BlogSection/WhenUsePdfAndDoc";
import JsonGenerator from "../components/JsonGenerator/JsonGenerator";
import JsonFormatGuide from "../components/BlogSection/JSONFormatGuide";
import MasteringPdfEditing from "../components/BlogSection/MasteringPDFEditing";
import PNGFormatGuide from "../components/BlogSection/PNGFormatGuide";
import JPGFormatGuide from "../components/BlogSection/JPGFormatGuide";
import WebPFormatGuide from "../components/BlogSection/WebPFormatGuide";
import GIFFormatGuide from "../components/BlogSection/GIFFormatGuide";
import ThreeGPFormatGuide from "../components/BlogSection/ThreeGPFormatGuide";
import MP4FormatGuide from "../components/BlogSection/MP4FormatGuide";
import MOVFormatGuide from "../components/BlogSection/MOVFormatGuide";
import WMVFormatGuide from "../components/BlogSection/WMVFormatGuide";
import AVIFormatGuide from "../components/BlogSection/AVIFormatGuide";
import MKVFormatGuide from "../components/BlogSection/MKVFormatGuide";
import MP3FormatGuide from "../components/BlogSection/MP3FormatGuide";
import FLACFormatGuide from "../components/BlogSection/FLACFormatGuide";
import AACFormatGuide from "../components/BlogSection/AACFormatGuide";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Home />} />
        {/* <Route path="home" element={<Home />} /> */}
        <Route path="sample-images" element={<SampleImage />} />
        <Route path="sample-images/:filePath" element={<SampleImage />} />
        <Route path="sample-videos" element={<SampleVideo />} />
        <Route path="sample-videos/:filePath" element={<SampleVideo />} />
        <Route path="sample-audios" element={<SampleAudio />} />
        <Route path="sample-audios/:filePath" element={<SampleAudio />} />
        <Route path="sample-documents" element={<SampleDocument />} />
        <Route path="sample-documents/:filePath" element={<SampleDocument />} />
        <Route path="sample-archives/" element={<SampleArchives />} />
        <Route path="sample-archives/:filePath" element={<SampleArchives />} />
        <Route path="sample-code/" element={<SampleCode />} />
        <Route path="sample-code/:filePath" element={<SampleCode />} />
        <Route path="about-us" element={<AboutUs />} />
        <Route path="contact-us" element={<ContactUs />} />
        <Route
          path="placeholder-image-generator"
          element={<PlaceholderImageGenerator />}
        />
        <Route path="convert-jpg-to-png" element={<ConvertJpgToPng />} />

        <Route path="json-generator" element={<JsonGenerator />} />
        <Route path="blogs" element={<Blogs />} />

        <Route
          path="how-to-convert-image-from-jpg-to-png"
          element={<ConvertJpgToPngBlog />}
        />
        <Route
          path="how-to-use-sample-files-for-testing"
          element={<SampleFilesGuide />}
        />
        <Route
          path="compare-png-webp-and-nine-patch-images"
          element={<ImageFormatComparison />}
        />
        <Route
          path="image-optimization-best-practices-for-web-performance"
          element={<ImageOptimization />}
        />
        <Route
          path="file-upload-security-a-complete-guide-for-developers"
          element={<FileUploadSecurity />}
        />
        <Route
          path="the-png-paradox-fixing-common-transparency-file-size-and-quality-mistakes"
          element={<PNGTroubleshooter />}
        />
        <Route
          path="mastering-pdf-editing-the-ultimate-guide-to-tools-tips-and-tricks"
          element={<MasteringPdfEditing />}
        />
        <Route
          path="why-your-pngs-are-secretly-slowing-down-your-site-and-how-to-fix-it"
          element={<PNGFormatGuide />}
        />
        <Route
          path="the-ultimate-jpg-guide-photos-compression-and-web-performance-explained"
          element={<JPGFormatGuide />}
        />
        <Route
          path="webp-the-modern-image-format-thats-changing-the-web"
          element={<WebPFormatGuide />}
        />
        <Route
          path="gif-files-the-internet-favorite-format-that-refuses-to-die"
          element={<GIFFormatGuide />}
        />
        <Route path="3gp-file-format-guide" element={<ThreeGPFormatGuide />} />
        <Route path="mp4-video-format-guide" element={<MP4FormatGuide />} />
        <Route path="mov-video-format-guide" element={<MOVFormatGuide />} />
        <Route path="wmv-video-format-guide" element={<WMVFormatGuide />} />
        <Route path="avi-video-format-guide" element={<AVIFormatGuide />} />
        <Route path="mkv-video-format-guide" element={<MKVFormatGuide />} />
        <Route path="mp3-audio-format-guide" element={<MP3FormatGuide />} />
        <Route path="flac-audio-format-guide" element={<FLACFormatGuide />} />
        <Route path="aac-audio-format-guide" element={<AACFormatGuide />} />

        <Route
          path="avif-the-next-generation-image-format-revolutionizing-web-performance"
          element={<AVIFNextGenImage />}
        />
        <Route
          path="three-file-types-you-should-never-open-from-a-stranger"
          element={<FileThreat />}
        />
        <Route
          path="pdf-vs-docx-what-is-the-difference-and-when-to-use-each"
          element={<WhenUsePdfAndDoc />}
        />
        <Route
          path="why-developers-everyone-love-json-format-data"
          element={<JsonFormatGuide />}
        />

        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="terms-of-service" element={<TermsOfService />} />
        <Route path="file-details" element={<FileDetails />} />
        {/* Add other routes here */}
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
